import Badge, { getBadgeColorForRole } from "./Badge";
import StatusBadge from "./StatusBadge";

export default function UserCard({ user, isCurrentUser = false, showBadge = true }) {
  const MAX_VISIBLE = 3;
  const clinics = user.clinic || [];
  const visible = clinics.slice(0, MAX_VISIBLE);
  const remaining = clinics.length - MAX_VISIBLE;

  return (
    <>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-medium text-smiles-darkGray truncate">{user.full_name}</span>
          {isCurrentUser && <span className="text-xs text-smiles-blue">(You)</span>}
          <Badge color={getBadgeColorForRole(user.role)}>{user.role_name}</Badge>
        </div>

        <div className="text-sm text-smiles-lightGray truncate">{user.email}</div>

        {clinics.length > 0 && (
          <div className="flex items-center gap-1.5 mt-1 flex-wrap">
            {visible.map((c) => (
              <Badge key={c} color="indigo">
                {c}
              </Badge>
            ))}
            {remaining > 0 && (
              <Badge color="gray" title={clinics.slice(MAX_VISIBLE).join(", ")}>
                +{remaining} more
              </Badge>
            )}
          </div>
        )}
      </div>
      {showBadge && (
        <div className="flex items-center gap-2 shrink-0">
          <StatusBadge status={user.status} />
        </div>
      )}
    </>
  );
}
